// @ts-expect-error - react-gtm-module doesn't have type definitions
import TagManager from "react-gtm-module";
import config from "~/config";

const gtmId = config.GTM_ID as string | undefined;

export const initializeTagManager = () => {
  if (gtmId) {
    TagManager.initialize({ gtmId });
  }
};
